export default __webpack_public_path__ + "static/media/Astronaut-01.3de1ede8.png";